import { render, staticRenderFns } from "./FindId.vue?vue&type=template&id=488b6b64&scoped=true&"
import script from "./FindId.vue?vue&type=script&lang=ts&"
export * from "./FindId.vue?vue&type=script&lang=ts&"
import style0 from "./FindId.vue?vue&type=style&index=0&id=488b6b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b6b64",
  null
  
)

export default component.exports